import './home.css'; 
import Header from '../../components/Header/Header'; 


export function Home() {
    return (
      <div className = "App">
        <div className = "gradient_bg">
          <Header /> 
        </div>
      </div>
    )
  }
  